import { types } from '@saucelabs/sl-module-root-cause';

export const NAMESPACE = 'builds-root-causes';
export default types.createTypes(NAMESPACE);
